
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/[slug]",
      function () {
        return require("private-next-pages/games/[slug]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/[slug]"])
      });
    }
  